import * as React from "react";
import { cn } from "@/libs/utils";
import { VariantProps, cva } from "class-variance-authority";

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const variants = cva(
  [
    "peer",
    "text-base flex py-[15px] px-4 w-full rounded border -outline-offset-2",
    "border-coolgray-20 bg-transparent",
    "placeholder:text-coolgray-40",
    "focus:outline focus:outline-2 focus:outline-blue-60",
    "disabled:cursor-not-allowed disabled:placeholder:text-coolgray-30",
    "aria-[invalid=true]:outline  aria-[invalid=true]:outline-2 aria-[invalid=true]:outline-red-60",
  ],
  {
    variants: {
      error: {
        true: "outline outline-2 outline-red-60",
      },
    },
  },
);

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  TextAreaProps & VariantProps<typeof variants>
>(({ className, error, ...props }, ref) => {
  return (
    <textarea
      className={cn(variants({ error }), className)}
      ref={ref}
      {...props}
    />
  );
});

TextArea.displayName = "TextArea";

export { TextArea };
